module.exports = __webpack_public_path__ + "static/media/learn.788b5846.svg";